import { Control, Controller } from 'react-hook-form';
import { realisation as rules } from 'further-ui/validations';
import useConsiderationCalculations, {
  ConsiderationTotalType,
} from '../../hooks/useConsiderationCalculations';
import FormField from 'further-ui/components/FormField';
import NumberInput from 'further-ui/components/NumberInput';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { InputAdornment, Typography, styled, Box } from '@mui/material';

const FlexCell = styled(Box)({ flex: 1 });
import { Row } from 'further-ui/components/Layout';

type Props = {
  control: Control<rules.CreateRealisationFormValues>;
  index: number;
  currencyCode: CurrencyCode;
  disabled: boolean;
};

const WithholdingTaxConsiderationRow: React.FC<Props> = ({
  control,
  index,
  currencyCode,
  disabled,
}) => {
  const { onWithholdingConsiderationTaxChange, setFieldFocus } =
    useConsiderationCalculations();

  return (
    <FormField
      label="Withholding tax payable"
      labelSize="sm"
      tooltip="This is the total withholding tax payable by the fund and its limited partners as part of the realisation. All consideration lines above should exclude withholding tax. If withholding tax is the buyer's responsibility or is paid on the fund's behalf (and not recorded as a fund-level expense), leave this field empty."
      layout="horizontal"
      breakpoint="md"
    >
      <Row spacing="sm">
        <FlexCell>
          <Controller
            name={`consideration.${index}.proRataConsideration.withholdingTaxPayable`}
            control={control}
            render={({
              field: { ref, onChange, ...rest },
              fieldState: { error },
            }) => (
              <NumberInput
                {...rest}
                currencyStartAdornment
                placeholder="Enter amount"
                disabled={disabled}
                currency={currencyCode}
                decimals={2}
                min={0}
                onChange={(value) => {
                  onChange(value);
                  onWithholdingConsiderationTaxChange(value ?? 0);
                }}
                onFocus={() => {
                  setFieldFocus(ConsiderationTotalType.WithholdingTax);
                }}
                error={!!error}
                fullWidth
                helperText={error?.message}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography variant="body2">Total</Typography>
                      </InputAdornment>
                    ),
                  },
                }}
              />
            )}
          />
        </FlexCell>
        <FlexCell />
      </Row>
    </FormField>
  );
};

export default WithholdingTaxConsiderationRow;
